import React from 'react';

import { CloseOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { RetrieveUserGroupSchema } from '@app/models/users';

import { useGroups } from '../../../providers';
import { NEW_GROUP_ID } from '../../../providers/constants';

interface IProps {
  record: RetrieveUserGroupSchema;
}

export const CancelAction: React.FC<IProps> = ({ record }) => {
  const commonT = useTranslation(NSKeys.common);
  const { editingRowKey, onCancelEdit } = useGroups();

  if (editingRowKey !== record.uid) {
    return null;
  }

  return (
    <Tooltip title={commonT.t('cancel')}>
      <Button type="link" icon={<CloseOutlined />} onClick={() => onCancelEdit(record.uid)} />
    </Tooltip>
  );
};
